import Joi from 'joi';
import ThreeDsPreference from '../enums/three-ds-preference';
//Joi.object().schema()

const DpaData = Joi.object().keys({
  dpaPresentationName: Joi.string()
    .optional()
    .allow(''),
  dpaThreeDsPreference: ThreeDsPreference,
  dpaUri: Joi.string()
    .optional()
    .allow(''),
  srcDpaId: Joi.string()
    .max(64)
    .optional()
    .allow('')
});

export default DpaData;
